import {
  Button,
  Grid,
  Stack,
  Tooltip,
  Typography,
  useMediaQuery,
} from '@mui/material';
import React, { useEffect, useRef, useState } from 'react';
import { useTheme } from '@emotion/react';
import CircularProgress from '@mui/material/CircularProgress';
import { postApiCall, viewContract } from 'api/apiService';
import { REQUEST_CONTRACT } from 'constant/app.config';
import { useParams } from 'react-router-dom/cjs/react-router-dom.min';
import { Document, Page, pdfjs } from 'react-pdf';
import Loading from 'assets/images/loading.png';
import { ImportExport } from '@mui/icons-material';
import InvitePopup from 'component/WelcomeBackScreen/InvitePopup';
import 'pdfjs-dist/webpack.mjs';

const hideDefaultLoaderStyle = `
  .view-contract-pdf {
    width: 100%;
    height: 100%;
    overflow-y: auto;
    overflow-x: hidden;
    scrollbar-width: none;
    -ms-overflow-style: none;
  }

  .view-contract-pdf::-webkit-scrollbar {
    display: none;
    width: 0;
    height: 0;
  }

  .view-contract-pdf .react-pdf__Document {
    width: 100%;
  }

  .view-contract-pdf .react-pdf__Page {
    width: 100% !important;
    margin: 0 !important;
    display: block !important;
  }

  .view-contract-pdf .react-pdf__Page canvas {
    display: block !important;
    width: 100% !important;
    height: auto !important;
  }

  .view-contract-pdf .react-pdf__Page__textContent {
    display: none !important;
  }

  .view-contract-pdf .react-pdf__Page__annotations {
    display: none !important;
  }
`;

export const Group = () => {
  return (
    <svg
      width="22"
      height="22"
      viewBox="0 0 22 22"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M9.68668 6.62494L12.5893 3.67279C14.1175 2.11854 16.6197 2.10797 18.161 3.64924V3.64924C19.6931 5.18136 19.6931 7.6654 18.161 9.19751L14.9971 12.3614C13.4764 13.8821 11.0253 13.9282 9.44853 12.4656L8.81168 11.8749"
        stroke="#6C2AD2"
        stroke-width="2"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M10.8719 16.086L7.96925 19.0382C6.44105 20.5924 3.93891 20.603 2.39763 19.0617V19.0617C0.86552 17.5296 0.865518 15.0455 2.39763 13.5134L5.56148 10.3496C7.08222 8.82883 9.53325 8.78277 11.1101 10.2453L11.7469 10.836"
        stroke="#6C2AD2"
        stroke-width="2"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
  );
};
export const Link = () => {
  return (
    <svg
      width="21"
      height="22"
      viewBox="0 0 21 22"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clip-path="url(#clip0_18943_50245)">
        <path
          d="M20.8198 0.68023C20.6458 0.50616 20.3847 0.452634 20.1563 0.544017L0.386757 8.45173C0.160556 8.54221 0.0090857 8.75763 0.000390401 9.00114C-0.00826388 9.2446 0.12758 9.47023 0.346767 9.57654L8.14251 13.3574L11.9234 21.1531C12.0265 21.3658 12.2418 21.4999 12.4768 21.4999C12.4841 21.4999 12.4915 21.4998 12.4988 21.4995C12.7422 21.4909 12.9577 21.3394 13.0482 21.1132L20.956 1.34378C21.0474 1.11524 20.9938 0.854259 20.8198 0.68023ZM2.13664 9.07705L17.8303 2.79967L8.47752 12.1523L2.13664 9.07705ZM12.4229 19.3633L9.34759 13.0223L18.7004 3.66969L12.4229 19.3633Z"
          fill="
#FFFFFF"
        />
      </g>
      <defs>
        <clipPath id="clip0_18943_50245">
          <rect
            width="21"
            height="21"
            fill="white"
            transform="translate(0 0.5)"
          />
        </clipPath>
      </defs>
    </svg>
  );
};
export const sent = () => {
  return (
    <svg
      width="21"
      height="22"
      viewBox="0 0 21 22"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M20.8198 0.68023C20.6458 0.50616 20.3847 0.452634 20.1563 0.544017L0.386757 8.45173C0.160556 8.54221 0.0090857 8.75763 0.000390401 9.00114C-0.00826388 9.2446 0.12758 9.47023 0.346767 9.57654L8.14251 13.3574L11.9234 21.1531C12.0265 21.3658 12.2418 21.4999 12.4768 21.4999C12.4841 21.4999 12.4915 21.4998 12.4988 21.4995C12.7422 21.4909 12.9577 21.3394 13.0482 21.1132L20.956 1.34378C21.0474 1.11524 20.9938 0.854259 20.8198 0.68023ZM2.13664 9.07705L17.8303 2.79967L8.47752 12.1523L2.13664 9.07705ZM12.4229 19.3633L9.34759 13.0223L18.7004 3.66969L12.4229 19.3633Z"
        fill="#6C2AD2"
      />
    </svg>
  );
};
export const chain = () => {
  return (
    <svg
      width="22"
      height="22"
      viewBox="0 0 22 22"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M9.68668 6.62494L12.5893 3.67279C14.1175 2.11854 16.6197 2.10797 18.161 3.64924V3.64924C19.6931 5.18136 19.6931 7.6654 18.161 9.19751L14.9971 12.3614C13.4764 13.8821 11.0253 13.9282 9.44853 12.4656L8.81168 11.8749"
        stroke="white"
        stroke-width="2"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M10.8739 16.086L7.9712 19.0382C6.44301 20.5924 3.94086 20.603 2.39959 19.0617V19.0617C0.867473 17.5296 0.867471 15.0455 2.39958 13.5134L5.56343 10.3496C7.08417 8.82883 9.5352 8.78277 11.112 10.2453L11.7489 10.836"
        stroke="white"
        stroke-width="2"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
  );
};
export const ViewContact = ({
  groupCall,
  requesttoview,
  setRequesttoview,
  viewContractStatus,
  contractreviewstatus,
  setOpensolicitorpopup,
  setTypeofsolicitorpopup,
}) => {
  const params = useParams();
  let status;
  let propertyId = params?.propertyId;
  const [trigger, setTrigger] = React.useState(false);
  const [file, setFile] = useState([]);
  const [openInvite, setOpenInvite] = useState(false);
  const [isViewed, setIsViewed] = useState(0);
  const [statusval, setStatusval] = useState();
  const [numPages, setNumPages] = useState(0);

  const pdfContainerRef = useRef(null);

  const theme = useTheme();
  const matchesmd = useMediaQuery(theme.breakpoints.down('md'));
  const matchessm = useMediaQuery(theme.breakpoints.down('sm'));

  const cntrlfunc = () => {
    viewContract(`${propertyId}/${isViewed}`).then((res) => {
      status = res?.ViewContractStatus;
      setStatusval(res?.ViewContractStatus);
      if (res?.status == 1) {
        groupCall();
        if (status.includes('Requested')) {
          setIsViewed(1);
        }

        setFile(res?.ViewContract);
      } else {
        setFile([]);
      }
    });
  };
  useEffect(() => {
    cntrlfunc();
  }, [trigger]);

  useEffect(() => {
    if (statusval == 'Requested' || 'Pending') {
      const timer = setTimeout(() => {
        setTrigger(!trigger);
      }, 10000);

      return () => clearTimeout(timer);
    }
  }, [statusval]);

  const [loading, setLoading] = useState(false);

  const Requestcontract = () => {
    const data = {
      propertyId: propertyId,
    };

    setLoading(true);

    postApiCall(REQUEST_CONTRACT, data)
      .then((res) => {
        if (res?.data?.status == 1) {
          groupCall();
          setLoading(false);
          cntrlfunc();
        }
      })
      .catch(() => setLoading(false));
  };

  useEffect(() => {
    if (requesttoview == true) {
      Requestcontract();
      cntrlfunc();
      setRequesttoview(false);
    }
  }, [requesttoview]);

  useEffect(() => {
    if (loading) {
      document.body.style.pointerEvents = 'none';
      document.body.style.overflow = 'hidden';
    } else {
      document.body.style.pointerEvents = 'auto';
      document.body.style.overflow = 'auto';
    }

    return () => {
      document.body.style.pointerEvents = 'auto';
      document.body.style.overflow = 'auto';
    };
  }, [loading]);

  return (
    <>
      <Grid
        sx={{
          position: 'relative',
          width: '100%',
          minHeight: 'auto',
          backgroundColor: '#F8F8F8',
          justifyContent: 'center',
          marginTop: '20px',
        }}
      >
        <style>{hideDefaultLoaderStyle}</style>

        <Stack>
          {file?.length > 0 && (
            <div class="frame-container">
              <Stack
                sx={{
                  position: 'absolute',
                  zIndex: 3,
                  bottom: matchessm ? '-150px' : -10,
                  display: 'flex',
                  alignItems: 'center',
                  flexDirection: matchessm ? 'column-reverse' : 'row',
                  gap: '10px',
                  padding: matchessm ? '25px 15px' : '0 0 10px 10px',
                  width: '100%',
                }}
              >
                <Stack
                  onClick={() => {
                    if (viewContractStatus !== 'Requested') {
                      setOpenInvite(true);
                    }
                  }}
                  sx={{
                    borderRadius: matchessm ? '8px' : '3px',
                    backgroundColor: matchessm ? 'white' : '#CBC3E3',
                    border: matchessm && '1px solid #2A3BD2',
                    padding: '10px 25px',
                    minWidth: matchessm ? '100%' : 'min-content',
                    opacity: viewContractStatus === 'Requested' ? 0.5 : 1,
                    pointerEvents:
                      viewContractStatus === 'Requested' ? 'none' : 'auto',
                  }}
                >
                  <Stack
                    direction={'row'}
                    spacing={2}
                    alignItems={'center'}
                    justifyContent={'center'}
                  >
                    {!matchessm && (
                      <Grid>
                        <Group />
                      </Grid>
                    )}
                    <Typography
                      sx={{
                        fontFamily: 'Poppins !important',
                        whiteSpace: 'nowrap',
                        fontStyle: 'normal !important',
                        fontWeight: matchessm ? 300 : 500,
                        fontSize: !matchessm ? '16px' : '20px',
                        color: matchessm ? '#2A3BD2' : '#6C2AD2',
                        cursor:
                          viewContractStatus === 'Requested'
                            ? 'not-allowed'
                            : 'pointer',
                      }}
                    >
                      Forward To Browsing Partner
                    </Typography>
                  </Stack>
                </Stack>

                <Tooltip
                  title={
                    contractreviewstatus == 'In Progress'
                      ? 'Already Forwarded'
                      : contractreviewstatus == 'Completed'
                      ? 'Completed'
                      : viewContractStatus != 'Reviewed' && 'Not Yet Reviewed!'
                  }
                  placement="top"
                  disableInteractive
                  componentsProps={{
                    tooltip: {
                      sx: {
                        bgcolor: '#fafafa',
                        boxShadow: '0px 2px 20px lightgray',
                        color: 'black',
                        padding: '10px',
                        fontFamily: 'poppins !important',
                        fontSize: '16px',
                        maxWidth: 'none',
                      },
                    },
                  }}
                >
                  <Stack
                    component={'div'}
                    sx={{
                      borderRadius: matchessm ? '8px' : '3px',
                      padding: '10px 25px',
                      backgroundColor: matchessm ? 'white' : '#6C2AD2',
                      border: matchessm && '1px solid #2A3BD2',
                      color: matchessm ? '#2A3BD2' : '#FFFFFF',
                      cursor:
                        viewContractStatus === 'Requested' ||
                        contractreviewstatus != 'Action Required'
                          ? 'not-allowed'
                          : 'pointer',
                      width: matchessm ? '100%' : 'min-content',
                      opacity:
                        viewContractStatus == 'Requested' ||
                        contractreviewstatus != 'Action Required'
                          ? 0.5
                          : 1,
                      pointerEvents: 'auto',
                    }}
                    onClick={() => {
                      setTypeofsolicitorpopup('forwardContract');
                      setOpensolicitorpopup(true);
                    }}
                  >
                    <Stack
                      direction={'row'}
                      spacing={2}
                      alignItems={'center'}
                      justifyContent={'center'}
                    >
                      {!matchessm && (
                        <Grid>
                          <Link />
                        </Grid>
                      )}
                      <Typography
                        sx={{
                          fontFamily: 'Poppins !important',
                          whiteSpace: 'nowrap',
                          fontStyle: 'normal !important',
                          fontWeight: matchessm ? 300 : 500,
                          fontSize: !matchessm ? '16px' : '20px',
                          color: matchessm ? '#2A3BD2' : '#FFFFFF',
                          cursor:
                            viewContractStatus === 'Requested' ||
                            contractreviewstatus != 'Action Required'
                              ? 'not-allowed'
                              : 'pointer',
                          pointerEvents: 'auto',
                        }}
                      >
                        Forward To Solicitor
                      </Typography>
                    </Stack>
                  </Stack>
                </Tooltip>
              </Stack>
              {statusval?.includes('Pending') && (
                <Grid
                  sx={{
                    width: '100%',
                    minHeight: matchessm ? '350px' : '700px',
                    zIndex: 5,
                    backgroundColor: 'transparent',
                    position: 'absolute',
                    backdropFilter: 'blur(2px)',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                  }}
                >
                  {!loading && (
                    <Button
                      variant="contained"
                      disabled={loading}
                      sx={{
                        textTransform: 'capitalize',
                        top: '50%',
                        fontFamily: 'Poppins !important',
                        fontStyle: 'normal !important',
                        fontWeight: '500 !important',
                        fontSize: '16px',
                        backgroundColor: '#6C2AD2',
                        borderRadius: '3px',
                        cursor: 'pointer',
                        '&:hover': {
                          backgroundColor: '#6C2AD2',
                          color: '#FFFFFF',
                        },
                      }}
                      onClick={() => {
                        if (status !== 'Requested') {
                          Requestcontract();
                        }
                      }}
                    >
                      {statusval && statusval == 'Requested'
                        ? 'Requested'
                        : 'Request to view Contract'}
                    </Button>
                  )}
                  {loading && (
                    <img
                      alt="Logo"
                      src={Loading}
                      className="loaderImage"
                      style={{ height: '40px', width: '40px' }}
                    />
                  )}
                </Grid>
              )}
              <div
                ref={pdfContainerRef}
                className="view-contract-pdf"
                style={{
                  width: '100%',
                  height: matchessm ? '350px' : '700px',
                  border: '1px solid #ddd',
                  boxSizing: 'border-box',
                  backgroundColor: '#fff',
                }}
              >
                <Document
                  file={file[0]?.propertyMedia}
                  onLoadSuccess={(pdf) => {
                    setNumPages(pdf.numPages);
                  }}
                  loading={null}
                  error="Failed to load PDF"
                >
                  {Array.from({ length: numPages }, (_, index) => (
                    <Page
                      key={`page_${index + 1}`}
                      pageNumber={index + 1}
                      width={pdfContainerRef.current?.clientWidth || undefined}
                    />
                  ))}
                </Document>
              </div>
            </div>
          )}
        </Stack>
      </Grid>

      {openInvite && (
        <InvitePopup
          openInvite={openInvite}
          setOpenInvite={setOpenInvite}
          BrowsingPartner={true}
        />
      )}
    </>
  );
};
